<template>
  <section class="app-main">
    <keep-alive>
      <router-view />
    </keep-alive>
  </section>
</template>

<script>
export default {
  name: 'AppMain',
}
</script>

<style lang="scss" scoped>
.app-main {
  flex: 1;
  width: 100%;
  position: relative;
  overflow: auto;
}
</style>
